import { render, staticRenderFns } from "./pointsAcc.vue?vue&type=template&id=92e3bfd2&scoped=true"
import script from "./pointsAcc.vue?vue&type=script&lang=js"
export * from "./pointsAcc.vue?vue&type=script&lang=js"
import style0 from "./pointsAcc.vue?vue&type=style&index=0&id=92e3bfd2&prod&lang=less&scoped=true"
import style1 from "./pointsAcc.vue?vue&type=style&index=1&id=92e3bfd2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e3bfd2",
  null
  
)

export default component.exports